<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">壞賬資料</span>
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- bad debt id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="壞賬編號："
                  label-for="id"
                  label-cols-md="3"
                >
                  <div class="">
                    {{ newBadDebtData.id }}
                    <!-- {{
                      newBadDebtData.id
                        ? newBadDebtData.receipt_number
                        : "系統自動生成"
                    }} -->
                  </div>
                </b-form-group>
              </b-col>

              <!-- bad_debt_date -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_bad_debt_date"
                >
                  <b-form-group
                    label="壞賬日期："
                    label-for="bad_debt_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newBadDebtData.bad_debt_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_customer_id"
                >
                  <b-form-group
                    label="客戶："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="customer_id"
                      v-model="newBadDebtData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerOptions"
                      :filter="customerSearch"
                      :clearable="false"
                      label="name_cn"
                      :reduce="(option) => option.id"
                      placeholder="選擇客戶"
                    >
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- invoice_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_invoice_id"
                >
                  <b-form-group
                    label="發票:"
                    label-for="receipt-date"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="invoice_id"
                      v-model="newBadDebtData.invoice_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="invoices"
                      :clearable="false"
                      label="invoice_number"
                      :reduce="(option) => option.id"
                      :filter="invoiceSearch"
                      :placeholder="
                        !newBadDebtData.customer_id ? '請先選擇客戶' : '選擇發票'
                      "
                      @input="updateAmountByInvoice"
                      :disabled="!newBadDebtData.customer_id"
                    >
                      <template
                        #option="{
                          invoice_number,
                          invoice_date,
                          amount,
                          total_amount,
                          total_paid,
                        }"
                      >
                        [{{ invoice_number }}] {{ invoice_date }} 總額:${{ (Number(amount) || Number(total_amount) || 0).toFixed(2) }} 已付:${{ (Number(total_paid) || 0).toFixed(2) }} {{ ((Number(amount) || Number(total_amount) || 0) - (Number(total_paid) || 0)).toFixed(2) > 0 ? '未付:$'+((Number(amount) || Number(total_amount) || 0) - (Number(total_paid) || 0)).toFixed(2) : '已付清' }}
                      </template>
                      <template
                        #selected-option="{
                          invoice_number,
                          invoice_date,
                          amount,
                          total_amount,
                          total_paid,
                        }"
                      >
                      [{{ invoice_number }}] {{ invoice_date }} 總額:${{ (Number(amount) || Number(total_amount) || 0).toFixed(2) }} 已付:${{ (Number(total_paid) || 0).toFixed(2) }} {{ ((Number(amount) || Number(total_amount) || 0) - (Number(total_paid) || 0)).toFixed(2) > 0 ? '未付:$'+((Number(amount) || Number(total_amount) || 0) - (Number(total_paid) || 0)).toFixed(2) : '已付清' }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- project_id -->
              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_project_id"
                >
                  <b-form-group
                    label="項目："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="project_id"
                      v-model="newBadDebtData.project_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="newProjectOptions"
                      :filter="projectSearch"
                      :clearable="false"
                      label="project_name"
                      :reduce="(option) => option.id"
                      :placeholder="
                        !newBadDebtData.customer_id
                          ? '請先選擇客戶'
                          : '選擇項目'
                      "
                      @input="
                        updateInvoiceSelection(
                          newBadDebtData.customer_id,
                          newBadDebtData.project_id
                        )
                      "
                      :disabled="!newBadDebtData.customer_id"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <b-col cols="12">
                <hr />
              </b-col>


              <!-- construction_address -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="施工地址："
                  label-for="construction_address"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="construction_address"
                    v-model="newBadDebtData.construction_address"
                    placeholder="施工地址"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_reason"
                >
                  <b-form-group
                    label="備註及原因："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="reason"
                      v-model="newBadDebtData.reason"
                      placeholder="輸入備註及原因"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_notes"
                >
                  <b-form-group
                    label="筆記："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="notes"
                      v-model="newBadDebtData.notes"
                      placeholder="輸入筆記"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_amount"
                >
                  <b-form-group
                    label="壞賬金額："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="notes"
                      type="number"
                      v-model="newBadDebtData.amount"
                      placeholder="輸入壞賬金額"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";

export default {
  data() {
    return {
      required,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    hide() {
      this.$router.replace("/bad-debt/list");
    },
    customerSearch(options, search) {
      return options.filter((item) => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase()) ||
          item.user_number.toLowerCase().includes(search.toLowerCase());
      });
    },
    projectSearch(options, search) {
      return options.filter((item) => {
        return item.project_name.toLowerCase().includes(search.toLowerCase());
      });
    },
    invoiceSearch(options, search) {
      return options.filter((item) => {
        return item.invoice_number.toLowerCase().includes(search.toLowerCase()) ;
      });
    },
    onSubmit() {
      console.log("=== onSubmit called ===");
      console.log("Form data:", this.newBadDebtData);
      console.log("Amount value:", this.newBadDebtData.amount);
      console.log("Amount type:", typeof this.newBadDebtData.amount);

      // 檢查必填欄位
      if (!this.newBadDebtData.customer_id) {
        this.makeToast("danger", "錯誤", "請選擇客戶");
        return;
      }
      if (!this.newBadDebtData.invoice_id) {
        this.makeToast("danger", "錯誤", "請選擇發票");
        return;
      }
      if (!this.newBadDebtData.amount || this.newBadDebtData.amount <= 0) {
        this.makeToast("danger", "錯誤", "請輸入有效的壞帳金額");
        return;
      }

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          console.log("Submitting data:", this.newBadDebtData);
          store
            .dispatch("bad-debt/editBadDebt", this.newBadDebtData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              this.$emit("refetech-data");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    badDebtData: {
      type: Object,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    invoiceOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newBadDebtData = ref({ id: 0 });

    watch(
      () => props.badDebtData,
      (newVal) => {
        newBadDebtData.value = { ...newVal };
        newBadDebtData.value.amount = newBadDebtData.value.amount
          ? Number(newBadDebtData.value.amount)
          : 0;

        // 延遲初始化，確保所有選項數據都已加載
        initializeDataWhenReady();
      }
    );
    const resetBadDebtData = () => {
      newBadDebtData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          project_id: null,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetBadDebtData);

    const newProjectOptions = ref([]);
    const isInitializing = ref(false);

    watch(
      () => newBadDebtData.value.customer_id,
      (newVal, oldVal) => {
        if (props.projectOptions && props.projectOptions.length > 0) {
          newProjectOptions.value = props.projectOptions.filter(
            (ele) => ele.customer_id == newBadDebtData.value.customer_id
          );
        }

        // 只有在用戶主動更改客戶時才清空其他欄位（不是初始化時）
        const isUserChange = oldVal && oldVal !== newVal && !isInitializing.value;
        if (isUserChange) {
          newBadDebtData.value.project_id = null;
          newBadDebtData.value.amount = null;
          newBadDebtData.value.construction_address = '';
        }

        if (newVal) {
          updateInvoiceSelection(newVal, isUserChange);
        }
      }
    );

    const invoices = ref([]);

    // 統一的數據初始化函數
    const initializeDataWhenReady = () => {
      console.log('=== initializeDataWhenReady called ===');
      console.log('customer_id:', newBadDebtData.value.customer_id);
      console.log('invoice_id:', newBadDebtData.value.invoice_id);
      console.log('invoiceOptions length:', props.invoiceOptions?.length || 0);

      // 檢查所有必要的數據是否已加載
      if (!newBadDebtData.value.customer_id || !props.invoiceOptions || props.invoiceOptions.length === 0) {
        console.log('Data not ready for initialization');
        return;
      }

      console.log('Proceeding with initialization...');

      // 設置初始化標記，避免觸發客戶變更的清空邏輯
      isInitializing.value = true;

      // 初始化發票選項
      updateInvoiceSelection(newBadDebtData.value.customer_id);

      // 檢查過濾後的發票選項
      console.log('Filtered invoices after updateInvoiceSelection:', invoices.value);

      // 如果有發票ID，設置施工地址
      if (newBadDebtData.value.invoice_id) {
        const selectedInvoice = props.invoiceOptions.find(
          (invoice) => invoice.id == newBadDebtData.value.invoice_id
        );
        console.log('Selected invoice found:', selectedInvoice);

        if (selectedInvoice) {
          newBadDebtData.value.construction_address = selectedInvoice.address || '';
          newBadDebtData.value.project_id =
            newBadDebtData.value.project_id || selectedInvoice.project_id || null;
          console.log('Construction address set to:', newBadDebtData.value.construction_address);
        }

        // 檢查發票是否在過濾後的選項中
        const invoiceInFilteredList = invoices.value.find(
          (invoice) => invoice.id == newBadDebtData.value.invoice_id
        );
        console.log('Invoice in filtered list:', invoiceInFilteredList);
      }

      // 延遲重置初始化標記，確保所有 watch 都已執行
      setTimeout(() => {
        isInitializing.value = false;
        console.log('Initialization completed');
      }, 100);
    };

    // 監聽 invoiceOptions 變化，當選項加載完成後嘗試初始化
    watch(
      () => props.invoiceOptions,
      (newOptions) => {
        if (newOptions && newOptions.length > 0) {
          initializeDataWhenReady();
        }
      }
    );

    // 監聽 customerOptions 變化，確保客戶數據加載完成
    watch(
      () => props.customerOptions,
      (newOptions) => {
        if (newOptions && newOptions.length > 0) {
          initializeDataWhenReady();
        }
      }
    );

    // 監聽 invoices 變化，用於調試
    watch(
      () => invoices.value,
      (newInvoices) => {
        console.log("=== invoices.value changed ===");
        console.log("New invoices count:", newInvoices.length);
        console.log("Current invoice_id:", newBadDebtData.value.invoice_id);
        if (newBadDebtData.value.invoice_id) {
          const selectedInvoice = newInvoices.find(inv => inv.id == newBadDebtData.value.invoice_id);
          console.log("Selected invoice in new list:", selectedInvoice ? "FOUND" : "NOT FOUND");
        }
      }
    );

    // watch(
    //   () => newBadDebtData.value.project_id,
    //   (newVal) => {
    //     console.log('project_id')
    //     updateInvoiceSelection(
    //       newBadDebtData.value.customer_id,
    //       newBadDebtData.value.project_id
    //     );
    //     newBadDebtData.value.amount = null
    //   }
    // );

    const updateInvoiceSelection = (customer_id, shouldClearInvoice = false) => {
      console.log("=== updateInvoiceSelection called ===");
      console.log("customer_id parameter:", customer_id);
      console.log("shouldClearInvoice:", shouldClearInvoice);
      console.log("newBadDebtData.customer_id:", newBadDebtData.value.customer_id);
      console.log("Current invoice_id:", newBadDebtData.value.invoice_id);

      // 只有在明確指示時才清空 invoice_id（用戶主動更改客戶時）
      if (shouldClearInvoice) {
        newBadDebtData.value.invoice_id = null;
        console.log("Invoice ID cleared due to customer change");
      }

      if (customer_id) {
        const filteredInvoices = props.invoiceOptions.filter((invoice) => {
          return Number(invoice.customer_id) == Number(customer_id);
        });

        console.log("All invoiceOptions:", props.invoiceOptions.length);
        console.log("Filtered invoices for customer", customer_id, ":", filteredInvoices.length);
        console.log("Filtered invoices:", filteredInvoices.map(inv => ({ id: inv.id, number: inv.invoice_number, customer_id: inv.customer_id })));

        invoices.value = filteredInvoices;

        // 檢查當前選中的發票是否在過濾後的列表中
        if (newBadDebtData.value.invoice_id) {
          const currentInvoiceInList = filteredInvoices.find(
            (invoice) => Number(invoice.id) == Number(newBadDebtData.value.invoice_id)
          );
          console.log("Current invoice in filtered list:", currentInvoiceInList ? "YES" : "NO");
          if (currentInvoiceInList) {
            console.log("Found invoice:", currentInvoiceInList.invoice_number);
          } else {
            console.log("Invoice ID", newBadDebtData.value.invoice_id, "not found in filtered list");
            // 檢查是否在原始列表中
            const inOriginalList = props.invoiceOptions.find(
              (invoice) => Number(invoice.id) == Number(newBadDebtData.value.invoice_id)
            );
            console.log("Invoice in original list:", inOriginalList ? "YES" : "NO");
            if (inOriginalList) {
              console.log("Original invoice customer_id:", inOriginalList.customer_id, "vs current customer_id:", customer_id);
            }
          }
        }
      } else {
        invoices.value = props.invoiceOptions || [];
      }

      console.log("Final invoices.value:", invoices.value.length);
    };

    const updateAmountByInvoice = () => {
      console.log("=== updateAmountByInvoice called ===");
      console.log("invoice_id:", newBadDebtData.value.invoice_id);
      console.log("invoiceOptions length:", props.invoiceOptions?.length || 0);

      if (props.invoiceOptions && props.invoiceOptions.length > 0 && newBadDebtData.value.invoice_id) {
        const data = props.invoiceOptions.find(
          (ele) => ele.id == newBadDebtData.value.invoice_id
        );

        console.log("Found invoice data:", data);

        if (data) {
          // 安全地處理數字轉換，避免 NaN
          // 優先使用 amount，如果沒有則使用 total_amount
          const invoiceAmount = Number(data.amount) || Number(data.total_amount) || 0;
          const totalPaid = Number(data.total_paid) || 0;
          const unpaidAmount = invoiceAmount - totalPaid;

          console.log("Invoice amount (from amount field):", data.amount);
          console.log("Invoice amount (from total_amount field):", data.total_amount);
          console.log("Final invoice amount:", invoiceAmount);
          console.log("Total paid:", totalPaid);
          console.log("Calculated unpaid amount:", unpaidAmount);

          // 壞帳金額應該是未付金額
          newBadDebtData.value.amount = unpaidAmount > 0 ? unpaidAmount : 0;

          // 自動填入施工地址
          newBadDebtData.value.construction_address = data.address || '';

          // 由發票帶出所屬項目，讓壞賬記錄可連回項目
          newBadDebtData.value.project_id = data.project_id || null;

          console.log("Set bad debt amount to:", newBadDebtData.value.amount);
        } else {
          console.log("Invoice not found in options");
          newBadDebtData.value.amount = 0;
        }
      } else {
        console.log("No invoice selected or no invoice options available");
        newBadDebtData.value.amount = 0;
      }
    };
    // watch(
    //   () => newBadDebtData.value.invoice_id,
    //   (newVal) => {

    //   }
    // );

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newBadDebtData,
      updateInvoiceSelection,
      invoices,
      newProjectOptions,
      updateAmountByInvoice,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>